// export const API_URL = 'https://flowcult.ru'
export const API_WITH_OUT_PROTOCOL = 'flowcult.ru'
export const API_URL = `http://${API_WITH_OUT_PROTOCOL}`
export const PROJECT_NAME = 'FLOWCULT'
export const PROJECT_INFO = {
  phone: '+7 (902) 060-36-56',
  phone_2: '+7 (908) 458-01-42',
  place: '',
}

export const isAuthenticated = () => {
  return !!localStorage.getItem('access_token')
}
